import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { defaultsDeep } from 'lodash/object';

import step from './step/reducer';
import requestDataSuccess from './requestDataSuccess/reducer';
import examData from './examData/reducer';
import notCorrectExam from './notCorrectExam/reducer';
import appealDataRequest from './appealDataRequest/reducer';
import appealCancelData from './appealCancelData/reducer';
import timeSlotChat from './timeSlotChat/reducer';
import gia from './gia/reducer';
import mainData from './mainData/reducer';
import mainDataChild from './mainDataChild/reducer';
import passport from './passport/reducer';
import passportChild from './passportChild/reducer';
import actRecord from './actRecord/reducer';
import applicant from './applicant/reducer';
import requestError from './requestError/reducer';
import appealFind from './appealFind/reducer';
import draft from './draft/reducer';
import serviceFavoriteStatus from './favorite/reducer';
import userChangedModal from './userChangedModal/reducer';

import { REPLACE_DRAFT_STATE } from './constants';

const rootReducer = (state, action) => {
  if (action.type === REPLACE_DRAFT_STATE) {
    const loadedState = action.payload.data.state;

    const newState = Object.keys(loadedState).reduce((accum, key) => {
      let result;

      if (Array.isArray(loadedState[key])) {
        result = [...loadedState[key]];
      } else {
        result = { ...loadedState[key] };
      }

      if (result.fetching || result.loading) {
        result.fetching = false;
        result.loading = false;
      }

      return {
        ...accum,
        [key]: result
      };
    }, {});

    defaultsDeep(newState, state);

    delete newState.error;
    delete newState.serviceFavoriteStatus;
    delete newState.requestDataSuccess;
    delete newState.requestError;
    delete newState.appealCancelData;
    delete newState.draft;
    newState.router = JSON.parse(JSON.stringify(state.router));

    return appReducer(Object.assign({}, state, newState), action);
  }

  return appReducer(state, action);
};

const appReducer = combineReducers({
  step,
  examData,
  requestDataSuccess,
  notCorrectExam,
  requestError,
  appealDataRequest,
  appealCancelData,
  timeSlotChat,
  gia,
  mainData,
  mainDataChild,
  passport,
  passportChild,
  actRecord,
  applicant,
  appealFind,
  draft,
  serviceFavoriteStatus,
  userChangedModal,
  router: routerReducer
});

export default rootReducer;
